import Mock from './mock';
import { getEnv } from 'ecx.saigon.ui.common';
import { getApprovals as query } from '../graphql/approvals';
import apolloClient from '../../utils/apollo-client';

export default async function getHRApprovals() {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return Mock.data.getApprovals;
  }
  const response = await apolloClient().then((client) =>
    client.query({
      query
    })
  );
  return response.data.getApprovals;
}
